import { FormEvent, useEffect } from 'react';
import {
  goalsPageRoute,
  landingPageRoute,
  singleGoalPageRoute,
} from '../../common/linkRoutes';
import { ASSIGNED, BEHIND, ON_PROGRESS, PLANNED } from '../../common/Types';
import Layout from '../../components/layout/Layout';
import { DailyTaskI } from '../../interfaces/DailyTaskInterface';
import { GoalI } from '../../interfaces/GoalInterface';
import { useStore } from '../../store/store';
import { BasicProps } from './GoalPage';
import { UserI } from '../../store/interfaces/storeStatesInterface';
import { goalRef } from '../../firebase/refs';
import GoalForm from '../../components/goal/goalForm';

const goalITemplate: GoalI = {
  key: '',
  title: '',
  des: '',
  details: {
    category: 'reading-book',
  },
  startTime: '',
  endTime: '',
  priority: '0',
  goalStatus: '',
  user_uid: '',
};

const SetGoalPage = (props: BasicProps) => {
  const { addGoal, setRedirect, user, addDailyTasks } = useStore();

  // const [snapshots, loading, error] = useList(goalRef);

  // const [formObj, setFormObj] = useState<GoalI>({ ...goalITemplate });

  useEffect(() => {
    return () => {
      goalRef.off();
    };
  }, []);

  const onSetGoal = async (
    event: FormEvent<HTMLFormElement>,
    formObj: GoalI
  ) => {
    event.preventDefault();
    if (!user) {
      setRedirect(landingPageRoute);
      return;
    }

    var _goalStatus;
    const _curDate = new Date();
    _curDate.setHours(0, 0, 0, 0);
    const _gStDate = new Date(formObj.startTime);
    _gStDate.setHours(0, 0, 0, 0);
    const _gEnDate = new Date(formObj.endTime);
    _gEnDate.setHours(0, 0, 0, 0);

    if (_gStDate <= _curDate && _curDate <= _gEnDate) {
      _goalStatus = ON_PROGRESS;
    } else if (_curDate <= _gStDate) {
      _goalStatus = PLANNED;
    } else if (_curDate > _gEnDate) {
      _goalStatus = BEHIND;
    } else {
      _goalStatus = ASSIGNED;
    }

    var goalObj = {
      ...formObj,
      user_uid: user.uid,
      goalStatus: _goalStatus,
    };

    // const newSetGoal = { ...goalObj, key: 'asdf' };
    const newSetGoal = goalRef.push();
    await newSetGoal.set({ ...goalObj, key: newSetGoal.key });

    if (newSetGoal.key === null) {
      return;
    }
    const newGoal = { ...goalObj, key: newSetGoal.key };
    getTasks(user, newGoal, (_tasks: DailyTaskI[]) => {
      if (_tasks.length) {
        addDailyTasks(_tasks);
      }

      addGoal(newGoal);
      setRedirect(singleGoalPageRoute);
    });
  };

  return (
    <Layout pageName="Set Goal" backRoute={goalsPageRoute} {...props}>
      <GoalForm initFormData={{ ...goalITemplate }} onSubmit={onSetGoal} />
    </Layout>
  );

  function formatHTMLDate(date: Date): string {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
  }

  function getTasks(_user: UserI, _goal: GoalI, callback: Function): void {
    const { key, startTime, endTime, priority, details } = _goal;
    var _dailyTasks: DailyTaskI[] = [];
    const _startDate = new Date(startTime);
    const _endDate = new Date(endTime);
    // To calculate the time difference of two dates
    var _difference_In_Time = _endDate.getTime() - _startDate.getTime();

    // To calculate the no. of days between two dates
    var _durationDays = _difference_In_Time / (1000 * 3600 * 24) + 1;

    if (details['category'] === 'reading-book') {
      const isPages = details['pages'] !== undefined;
      const _totalNum = !isPages
        ? Number(details['chapters'])
        : Number(details['pages']);
      const _eachDayNum =
        _durationDays > _totalNum
          ? _durationDays / _totalNum
          : _totalNum / _durationDays;
      const roundedDayNum = Math.ceil(_eachDayNum);
      const _details = {
        category: details['category'],
      };
      var startNo = 0;
      for (let i = 0; i < _durationDays; i++) {
        if (startNo >= _totalNum) {
          break;
        }
        var _date = _startDate;
        _date.setDate(_date.getDate() + (i === 0 ? 0 : 1));
        const add = startNo + roundedDayNum;
        var _till = add <= _totalNum ? add : _totalNum;

        const _tempStartN0 = startNo + 1;
        const _taskDetail =
          _tempStartN0 === _till
            ? `${_tempStartN0}`
            : `${_tempStartN0} to ${_till}`;
        const _eachDetails = isPages
          ? { ..._details, pages: _taskDetail }
          : { ..._details, chapters: _taskDetail };

        startNo = _till;

        var _tStatus;
        const _curDate = new Date();
        _curDate.setHours(0, 0, 0, 0);
        const _tAsDate = new Date(_date);
        _tAsDate.setHours(0, 0, 0, 0);

        if (_tAsDate < _curDate) {
          _tStatus = BEHIND;
        } else if (_curDate === _tAsDate) {
          _tStatus = ON_PROGRESS;
        } else {
          _tStatus = ASSIGNED;
        }

        const newTask: DailyTaskI = {
          user_uid: _user.uid,
          goal_key: key,
          assignedDate: formatHTMLDate(_date),
          taskStatus: _tStatus,
          priority: priority,
          details: _eachDetails,
        };
        _dailyTasks = [..._dailyTasks, newTask];
      }
    }
    callback(_dailyTasks);
  }
};

export default SetGoalPage;
